// v1.112. Sun + cave glyphs for the region-view toggle. Stroked
// SVG, currentColor so the active/inactive color from the parent
// button shines through. Sized by the `size` prop (cqw string).
export function SunIcon({ size }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
    </svg>
  );
}

export function CaveIcon({ size }) {
  // Stylised mountain silhouette with a dark cave-mouth arch. Reads
  // as "underground / subsurface" against the sun above.
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M2 20 L9 8 L13 14 L17 9 L22 20 Z" />
      <path d="M9.5 20 a2.5 3 0 0 1 5 0" fill="currentColor" stroke="none" />
    </svg>
  );
}
